<template>
    <div class="h100p">
        <el-header>
            <h1><img :src="pageConfig.icon ? pageConfig.icon : require('../../assets/img/logo.png')" alt=""
                     style="width:38px;margin-top:-3px;"> {{ pageConfig.name }}</h1>
            <el-dropdown class="headerRight" trigger="click" @command="logout">
                <span class="el-dropdown-link"><img
                        src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"/><span
                        style="cursor:pointer;color:#0070de">{{ info.examineeName }}</span></span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>{{ logoutTextConfig.name }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-header>

        <el-container>
            <el-main style="background-color: rgb(247, 251, 255)">
                <look-paper></look-paper>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import LookPaper from "@/views/achievement/lookPaper.vue";
export default {
    name: "reviewDetails",
    components: {
        LookPaper
    },
    data() {
        return {
            pageConfig: {
                name: '',                      // 名称，原：1+X证书考试系统
                icon: '',                      // 图标（为空则按照原设计）
            },
            info: {
                examineeName: ''
            },
        }
    },
    computed: {
        logoutTextConfig() {
            return this.$store.state.global.textConfig.logout
        }
    },
    created() {
        let config = this.$store.state.projectConfig
        this.pageConfig = config.page
        this.$store.dispatch("getExamCurrent").then(res => {
            if (res.status == 200 && res.data) {
                this.info = res.data
            }

            if (!this.info.examineeName) {
                this.$store.dispatch("getExamCurrentName").then(data => {
                    this.info.examineeName = data.data;
                });
            }
        })

    },
    methods: {
        logout() {
            sessionStorage.clear()
            localStorage.removeItem('1+XUserIdentity')
            localStorage.removeItem('1+XPermissionsList')
            window.location.href = '/logout'
            // this.$store.dispatch("userLogout").then(res => {
            //     if (res.status == 200) {
            //         this.$message({
            //             type: 'success',
            //             message: this.logoutTextConfig.message
            //         })
            //         localStorage.removeItem("1+XUserIdentity")
            //         localStorage.removeItem('1+XPermissionsList')
            //         location.reload()
            //     }
            // })
        }
    }
}
</script>

<style scoped>
.el-header {
    color: #0070de;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    font-size: 15px;
}

.el-header h1 {
    font-weight: 600;
    font-size: 20px;
}

.headerRight img {
    height: 40px;
    width: 40px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 12px;
}

.el-container {
    height: calc(100% - 60px);
    overflow: auto;
}
</style>
